import { useSelector } from 'react-redux';
import { ReduxKey, RootState } from '../reducers';

export default function useReduxKey<T = any>(key: ReduxKey): T {
  return useSelector<RootState, ReturnType<RootState[typeof key]>>((state: RootState) => state[key]);
}
